import { useEffect } from "react";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

/** Call anywhere: trackEvent("AddToCart", { value: 249, currency: "INR" }) */
export const trackEvent = (event, params = {}) => {
  if (window.fbq) {
    window.fbq("track", event, params);
  }
};

/**
 * Meta (Facebook & Instagram) Pixel. Inert until REACT_APP_META_PIXEL_ID
 * is set in frontend/.env — then loads the official pixel, inits it and
 * fires PageView once per load.
 */
export default function MetaPixel() {
  useEffect(() => {
    if (!PIXEL_ID) return undefined;
    if (window.fbq) return undefined;

    const n = (window.fbq = function (...args) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");

    return undefined;
  }, []);

  return PIXEL_ID ? (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
        alt=""
      />
    </noscript>
  ) : null;
}
